var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"c",staticClass:"crop",attrs:{"width":_vm.width,"height":_vm.height},on:{"tap":_vm.onTap,"panstart":_vm.onPanstart,"panmove":_vm.onPanmove,"panend":_vm.onPanend}})}
var staticRenderFns = []

export { render, staticRenderFns }